<template>
    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <!--Панель поиска-->
            <SearchPanel
                v-model="search"
                :has-filter="true"
                @on-filter-click="onFilterClick"
            />
        </Toolbar>

        <div class="white-panel-items" v-if="$helpers.isExtendedFilterPanelVisible(extendedTableFilter)">
            <ExtendedFilterPanel v-bind:value.sync="extendedTableFilter" />
        </div>

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :item-class="itemRowBackground"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents.Document' })"
                    show-expand
                    @item-expanded="itemExpanded"
                    :expanded.sync="expanded"
                    >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.data-table-expand`]="{ isExpanded, expand }">
                        <v-btn 
                            icon
                            x-small
                            plain
                            class="expand-cust-btn"
                            @click="expand(true)" 
                            v-if="!isExpanded"
                        >
                            <v-icon>
                                fas fa-caret-right
                            </v-icon>
                        </v-btn>
                        <v-btn 
                            icon
                            x-small
                            plain
                            class="expand-cust-btn"
                            @click="expand(false)" 
                            v-else
                        >
                            <v-icon>
                                fas fa-caret-down
                            </v-icon>
                        </v-btn>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <div class="table-expanded-wrapper">

                                <template v-if="item._info">
                                    <v-treeview 
                                        dense
                                        :items="item._info"
                                        class="cust-treeview-in-list"
                                        :open.sync="open[item.id]"
                                        >
                                        <template v-slot:label="{ item }">

                                            <template v-if="item.text=='Link'">
                                                    
                                                <div class="d-flex align-center">
                                                    <span class="linked-docs-title">{{ $t(GetLinkedTypes[item.type]) }}</span>
                                                    <div class="onlyReadData more-per-lab-wrap">
                                                        <v-doc-chip
                                                            v-for="(doc, index) in item.values"
                                                            :key="item.type+index"
                                                            :id="doc.Values[6]"
                                                            :link-id="doc.Values[0]"
                                                            :name="$t(GetDocumentTypes[doc.Values[9]]) + ' № ' + doc.Values[2] + ` ${$t('от_время')} ` + doc.Values[3] + (doc.Values[5] ? ' (' + doc.Values[5] + ')' : '')" 
                                                            iconColor="#7289DA"
                                                            :is-linked-document="true"
                                                            :source-document-id="item.sourceDocumentId"
                                                        />
                                                    </div>
                                                </div>

                                            </template>
                                            <template v-else-if="item.text=='Notify'">
                                                <div class="d-flex ctil-row-wrap">
                                                    <div class="flex-grow-1">
                                                        <div class="elipsis-text-wrap">
                                                            <span>
                                                                {{ $t("Уведомление") }}
                                                            </span>
                                                            <span>
                                                                {{ item.Values[0] }}
                                                            </span>
                                                            <span>
                                                                <v-employee-chip :id="item.Values[3]" :name="item.Values[2]" /> 
                                                            </span>
                                                            <div class="etw-text-container" v-tooltip.top-center="item.Values[1]">
                                                                <span class="etw-text">
                                                                    {{ item.Values[1] }}
                                                                </span>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </div>                                           
                                            </template>
                                            <template v-else-if="item.text=='0'">
                                                <div class="d-flex ctil-row-wrap">
                                                    <div class="d-flex align-center flex-grow-1">
                                                        <div class="elipsis-text-wrap">
                                                            <span 
                                                                v-if="item.Values[14] == 'True'"
                                                                :class="item.Values[5] == 7 ? 'text-decoration-line-through' : ''"
                                                            >
                                                                {{ $t("Резолюция") }}
                                                            </span>
                                                            <span 
                                                                v-else
                                                                :class="item.Values[5] == 7 ? 'text-decoration-line-through' : ''"
                                                            >
                                                                {{ $t("Внешняя") }}
                                                            </span>
                                                            
                                                            <span :class="item.Values[5] == 7 ? 'text-decoration-line-through' : ''">
                                                                {{ item.Values[8] }}
                                                            </span>

                                                            <v-employee-chip v-if="item.Values[14] == 'True'" :id="item.Values[7]" :name="item.Values[1]" :is-employee="true" />
                                                            <v-enterprise-chip v-else :name="item.Values[1]" />

                                                            <i v-if="item.Values[13] === 'True'" class="fas fa-glasses signer-control-i" v-tooltip.top-center="isSignerControlTooltip"></i>

                                                            <div class="etw-text-container" v-tooltip.top-center="item.Values[2]">
                                                                <span :class="[item.Values[5] == 7 ? 'text-decoration-line-through' : '', 'etw-text']">
                                                                    {{ item.Values[2] }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-center flex-grow-0" style="width:110px;">
                                                        <span 
                                                            v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss')"
                                                            :class="item.Values[5] == 7 ? 'text-decoration-line-through' : ''"
                                                        >
                                                            {{ dateFormat(item.Values[4], 'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss') }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex align-center flex-grow-0 status-dropdown-col" style="width:150px;">
                                                        <div class="onlyReadData more-per-lab-wrap"> 
                                                            <StatusChip
                                                                v-if="item.Values[14] == 'False' && item.hasExecutions"
                                                                :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1', 10))]"
                                                            />

                                                            <template v-else-if="item.Values[14] == 'True'">
                                                                <StatusChip
                                                                    v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss') && getDaysDiff(item.Values[4]) > -1 && item.Values[5] == '5'"
                                                                    :status="avaibleStatuses[$helpers.getTaskStatus(1)]"
                                                                />
                                                                <StatusChip
                                                                    v-else
                                                                    :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1'), 10)]"
                                                                />

                                                            </template>
                                                            
                                                            <StatusChip v-if="item.Values[19] || null" :status="avaibleStatuses[$options.rssStatusKeys[parseInt(item.Values[19] || '0')]]" />                    
                                                        </div>
                                                    </div>
                                                </div>                                              
                                            </template>
                                            <template v-else-if="item.text=='1'">
                                                <div class="d-flex ctil-row-wrap">
                                                    <div class="d-flex align-center flex-grow-1">
                                                        <div class="elipsis-text-wrap">
                                                            <span>{{$t("Исполнитель")}}</span>
                                                            <v-enterprise-chip
                                                                v-if="item.Values[9] === '00000000-0000-0000-0000-000000000000'"
                                                                :name="item.Values[1]"
                                                                :iconColor="executerStatusColor(item.Values[8])"
                                                                :main="item.Values[6] == 'True'"
                                                            />
                                                            <v-workplace-chip
                                                                v-else
                                                                :id="item.Values[9]"
                                                                :name="item.Values[0]"
                                                                :iconColor="executerStatusColor(item.Values[8])"
                                                                :main="item.Values[6] == 'True'"
                                                                :is-employee="true"
                                                            />

                                                            <div class="etw-text-container" v-tooltip.top-center="item.Values[5]">
                                                                <span class="etw-text">
                                                                    {{ item.Values[5] }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-center flex-grow-0" style="width:110px;">
                                                        <span v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss')">
                                                            {{ dateFormat(item.Values[4], 'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss') }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex align-center flex-grow-0 status-dropdown-col" style="width:150px;">
                                                        <StatusChip :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[2] || '-1', 10))]" />
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else-if="item.text=='2'">
                                                <div class="d-flex ctil-row-wrap">
                                                    <div class="d-flex align-center flex-grow-1">
                                                        <div class="elipsis-text-wrap">
                                                            <span>
                                                                {{ $t("Пункт") }} № {{ item.Values[15] }}
                                                            </span>
                                                            
                                                            <span>
                                                                {{ item.Values[8] }}
                                                            </span>

                                                            <v-employee-chip v-if="item.Values[14] == 'True'" :id="item.Values[7]" :name="item.Values[1]" :is-employee="true" />
                                                            <v-enterprise-chip v-else :name="item.Values[1]" />

                                                            <i v-if="item.Values[13] === 'True'" class="fas fa-glasses signer-control-i" v-tooltip.top-center="isSignerControlTooltip"></i>

                                                            <div class="etw-text-container" v-tooltip.top-center="item.Values[2]">
                                                                <span class="etw-text">
                                                                    {{ item.Values[2] }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-center flex-grow-0" style="width:110px;">
                                                        <span v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss')">
                                                            {{ dateFormat(item.Values[4], 'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss') }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex align-center flex-grow-0 status-dropdown-col" style="width:150px;">
                                                        <div class="onlyReadData more-per-lab-wrap"> 
                                                            <StatusChip
                                                                v-if="item.Values[14] == 'False' && item.hasExecutions"
                                                                :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1', 10))]"
                                                            />

                                                            <template v-else-if="item.Values[14] == 'True'">
                                                                <StatusChip
                                                                    v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss') && getDaysDiff(item.Values[4]) > -1 && item.Values[5] == '5'"
                                                                    :status="avaibleStatuses[$helpers.getTaskStatus(1)]"
                                                                />
                                                                <StatusChip
                                                                    v-else
                                                                    :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1'), 10)]"
                                                                />

                                                            </template>
                                                            
                                                            <StatusChip v-if="item.Values[19] || null" :status="avaibleStatuses[$options.rssStatusKeys[parseInt(item.Values[19] || '0')]]" />                    
                                                        </div>
                                                    </div>
                                                </div>        
                                            </template>                                      
                                            <template v-else>
                                                {{ getLabel(item) }}
                                            </template>
                                            
                                        </template>
                                    </v-treeview>
                                </template>
                                <v-progress-linear v-else
                                    color="#a94442"
                                    indeterminate
                                    rounded
                                    height="6"
                                ></v-progress-linear>

                            </div>
                        </td>
                    </template>

                    <template v-slot:[`item.regdate`]="{ item }">
                        <div>{{dateFormat(item.regdate, 'DD.MM.YYYY')}}</div>
                    </template>
                    
                    <template v-slot:[`item.theme`]="{ item }">
                        <div class="elipsis-text-wrap">                        
                            <!--<v-doc-type-chip :type="item.doctypeof" :text="item.doctype"/>-->
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.theme">
                                    {{item.theme}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.authorname`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <v-employee-chip :id="item.authorid" :name="item.authorname" />
                        </div>
                    </template>

                    <template v-slot:[`item.signername`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <v-employee-chip v-if="item.signername" :id="item.signeremployeeid" :name="item.signername" />
                        </div>
                    </template>

                    <template v-slot:[`item.ordworkstatus`]="{ item }">
                        <StatusChip :status="avaibleStatuses[$helpers.GetORDStatus(item.ordworkstatus)]"/>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>

        <!-- модалка -->
        <InnerExFilterDlg
            v-model="extendedTableFilter"
            ref="ExFilterDlgRef"
        />

    </div>
</template>

<script>
import _ from 'lodash';
import sys from "@/services/system";
import adapter from "@/services/adapter";
import { mapGetters, mapActions } from 'vuex';
import { httpAPI } from "@/api/httpAPI";

import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import ExtendedFilterPanel from '@/components/documents/ExtendedFilterPanel.vue';
import StatusChip from '@/components/global/chips/StatusChip';
import InnerExFilterDlg from '@/components/documents/dialogs/extended-filters/Inners.vue';

import i18n from '@/i18n';

export default {
    rssStatusKeys:["", "rssOnSign", "rssSignedByChief", "rssSended"],
    columnIndex: {
        'regnumber': 2,
        'regdate': 4,
        'correspondent': 5,
        'theme': 6,
        'authorname': 12
    },
    controlDocumentStates: {
        "All": -1,
        "NoControl": 0,
        "OnControl": 1,
        "Today": 2,
        "Expired": 3,
        "TakeOffControl": 4
    },
    name: "CorrespondenceOrds",
    components: {
        Toolbar,
        SearchPanel,
        ExtendedFilterPanel,
        StatusChip,
        InnerExFilterDlg
    },
    computed : {
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        ...mapGetters('documents/references',  { GetLinkedTypes: 'GetLinkedTypes', GetDocumentTypes: 'GetDocumentTypes', avaibleStatuses: 'GetAvaibleStatuses' }),
        collection() {
            return this.$store.getters['correspondence/ords/getCollection'];
        },
        isSignerControlTooltip () {
            return this.$t("Личный_контроль");
        },
        headers() {
            return [
                { text: this.$t("Рег._№"), value: 'regnumber', width: '150px' },
                { text: this.$t("Рег._дата"), value: 'regdate', width: '110px' },
                { text: this.$t("Краткое_содержание"), value: 'theme'},
                { text: this.$t("Автор"), value: 'authorname', width: '150px'},
                { text: this.$t("Подписал"), value: 'signername', width: '150px'},
                { text: this.$t("Статус"), value: 'ordworkstatus', width: '150px', sortable: false, class: 'status-col'}
            ];
        },
        status: {
            get: function() {
                return this.$store.getters['correspondence/ords/getStatus'];
            },
            set: function(newValue) {
                if (newValue) {
                    this.$store.commit('correspondence/ords/SET_STATUS', newValue);
                }
            }
        },
        search: {
            get: function() {
                return this.$store.getters['correspondence/ords/getSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('correspondence/ords/SET_SEARCH', v);
            }, 500)
        },
        extendedTableFilter: {
            get: function() {
                return this.$store.getters['correspondence/ords/getExtendedFilter'];
            },
            set: function(newValue) {
                if (newValue) {
                    this.$store.commit('correspondence/ords/SET_EXTENDED_FILTER', newValue);
                }
            }
        },
        options: {
            get: function() {
                return this.$store.getters['correspondence/ords/getTableOptions'];
            },
            set: function(newValue) {
                if (newValue) {
                    this.$store.commit('correspondence/ords/SET_TABLE_OPTION', newValue);
                }
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                ControlDocumentState: this.$options.controlDocumentStates[this.status],
                extendedFilterData: this.$helpers.getOnlySelectedParams(this.extendedTableFilter)
            }
        },
    },
    data() {
        return {
            loading: false,
            total: 0,
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,

            expanded: [],
            open: {},
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        dateFormat: sys.dateFormat,
        getDaysDiff: sys.getDaysDiff,
        executerStatusColor: sys.getExecuterStatusColor,
        itemRowBackground: (item) => item.readed === true ? '' : 'font-weight-bold',
        getLabel: (item) => item.Values.toString(),
        onToolbarClick(event, btn) {
            this[btn.Action](btn);
        },
        async Refresh() {
            await this.loadCollectionData();
            await this.getData(true);
        },
        async Export() {
            let filter = this.getTableFilterObject();
            delete filter.Limit;
            delete filter.Offset;
            filter.DocumentTypeC4 = 1;

            let exportURI = `api/download/export?param=${JSON.stringify(filter)}&mode=${process.env.NODE_ENV}`;

            if (process.env.NODE_ENV === "production")
                exportURI += `&token=${this.$store.getters['auth/getUserInfo']?.Token}`;

            let text = i18n.t('Экспорт_списка_ОРД_от_formatedDateTime.message', { formatedDateTime: this.$moment().format('DD.MM.YYYY HH.mm.ss') });

            this.$eventBus.$emit('on-get-report', { url: exportURI, text: text, type: 'xls' });
        },
        async onFilterClick() {
            try
            {
                await this.$refs.ExFilterDlgRef.open();
            }
            catch (ex)
            {
                if (ex.isCancelled) 
                    console.warn(ex.message);
                else
                    console.error(ex.message);
            }
        },
        async loadCollectionData() {
            this.setOverlayVisible({ visible: true });

            try
            {
                let response = await httpAPI({
                    url: `api/actions/collection?type=Documents.Correspondence`,
                    method: 'GET'
                });

                if (response) {
                    this.$store.commit('documents/toolbar/SET_MENU', { menu: response.data.Payload.Data.Menu });
                }
            }
            finally
            {
                this.setOverlayVisible({ visible: false });
            }
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, ControlDocumentState, extendedFilterData } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "regdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 4;
            const DocumentTemplateType = this.collection.split('_')[1];
            return { 
                SearchStr,
                DocType: "Avrora.Objects.Modules.Docflow.DocflowObjects.InnerDocument",
                //DocumentTypeC4: "1",
                DocumentTemplateType,
                ControlDocumentState,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage,
                ...extendedFilterData
            };
        },
        async getData(isRefresh = false) {
            this.$eventBus.$emit('update_correspondents_counters');
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
                
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;
            
            let response = await httpAPI({
                url: `api/correspondence/list?collection=Ords&filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET'
            });
            
            this.open = {};
            this.expanded = [];

            this.entities = response.data?.Payload?.data ?? [];
            this.total = response.data?.Payload?.total ?? 0;

            this.loading = false;      
        },
        async oneStatusColWidth() {
            var parent = document.getElementsByClassName('content-box')[0];
            var status_col_obj = parent.getElementsByClassName('status-col');
            var status_dropdown_col_obj = parent.getElementsByClassName('status-dropdown-col');
            var status_col_w = status_col_obj.length > 0 ? status_col_obj[0].clientWidth : 0;

            if (status_dropdown_col_obj.length > 0) {
                for (var index = 0; index < status_dropdown_col_obj.length; index++) {
                    status_dropdown_col_obj[index].style.width = status_col_w + "px";
                }
            }
        },
        async itemExpanded(val) {
            if (!val.value) return;
            
            this.$set(val.item, '_info', null)

            let response = await httpAPI({
                url: `api/correspondence/getdocumentchildren?id=${val.item.id}`,
                method: 'GET',
                headers: { 'isCommon': val.item.iscommon }
            });
            
            let data = response?.data?.Payload?.Data?.Object?.data;
            
            if (data)
            {
                let treeData = adapter.transformTreeData(null, data, val.item.id);
                this.$set(val.item, '_info', treeData)
            }   
        },
    },
    watch: {
        filter: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        open: {
            handler() {
                this.$nextTick(this.oneStatusColWidth);
            },
            deep: true,
        }
    },
    async created() {
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    },
    mounted() {
        this.$nextTick(this.oneStatusColWidth);
        window.addEventListener('resize', this.oneStatusColWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.oneStatusColWidth);
    },
    beforeRouteEnter(to, from, next) {
        next(async vm =>
        {
            const collection = to.params.collection;
            vm.$store.commit('correspondence/ords/SET_COLLECTION', collection);
            await vm.loadCollectionData();
        });
    },
    async beforeRouteUpdate(to, from, next) {
        const collection = to.params.collection;
        this.$store.commit('correspondence/ords/SET_COLLECTION', collection);
        await this.loadCollectionData();
        next();
    },
}
</script>